// @flow
import {
    LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_FAILED,
    LOGOUT_USER,
    REGISTER_USER, REGISTER_USER_SUCCESS, REGISTER_USER_FAILED,
    FORGET_PASSWORD, FORGET_PASSWORD_SUCCESS, FORGET_PASSWORD_FAILED,
    RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILED,
    BALANCE_REQUEST, BALANCE_REQUEST_SUCCESS, BALANCE_REQUEST_FAILED,
    SIMULATE_USER, SIMULATE_USER_SUCCESS, SIMULATE_USER_FAILED,
    TOGGLE_ACCOUNT, TOGGLE_ACCOUNT_SUCCESS, TOGGLE_ACCOUNT_FAILED,
    TOGGLE_PROFILE, TOGGLE_PROFILE_SUCCESS, TOGGLE_PROFILE_FAILED, LOGIN_SSO, LOGIN_SSO_SUCCESS, LOGIN_SSO_FAILED,
} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type AuthAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value?: boolean };

const Auth = (state: State = INIT_STATE, action: AuthAction) => {
    switch (action.type) {
        case LOGIN_USER:
            return { ...state, loading: true };
        case LOGIN_USER_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case LOGIN_USER_FAILED:
            return { ...state, error: action.payload, loading: false };
        case REGISTER_USER:
            return { ...state, loading: true };
        case REGISTER_USER_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case REGISTER_USER_FAILED:
            return { ...state, error: action.payload, loading: false };
        case LOGOUT_USER:
            return { ...state, user: null };
        case BALANCE_REQUEST:
            return { ...state, balanceLoading: true };
        case BALANCE_REQUEST_SUCCESS:
            return { ...state, balanceRequestStatus: action.payload, balanceLoading: false, balanceError: null };
        case BALANCE_REQUEST_FAILED:
            return { ...state, balanceError: action.payload, balanceLoading: false };
        case FORGET_PASSWORD:
            return { ...state, loading: true };
        case FORGET_PASSWORD_SUCCESS:
            return { ...state, passwordResetStatus: action.payload, loading: false, error: null };
        case FORGET_PASSWORD_FAILED:
            return { ...state, error: action.payload, loading: false };
        case RESET_PASSWORD:
            return { ...state, loading: true };
        case RESET_PASSWORD_SUCCESS:
            return { ...state, passwordResetStatus: action.payload, loading: false, error: null };
        case RESET_PASSWORD_FAILED:
            return { ...state, error: action.payload, loading: false };
        case SIMULATE_USER:
            return { ...state, loading: true };
        case SIMULATE_USER_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case SIMULATE_USER_FAILED:
            return { ...state, error: action.payload, loading: false };
        case TOGGLE_ACCOUNT:
            return { ...state, loading: true };
        case TOGGLE_ACCOUNT_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case TOGGLE_ACCOUNT_FAILED:
            return { ...state, error: action.payload, loading: false };
        case TOGGLE_PROFILE:
            return { ...state, loading: true };
        case TOGGLE_PROFILE_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case TOGGLE_PROFILE_FAILED:
            return { ...state, error: action.payload, loading: false };
        case LOGIN_SSO:
            return { ...state, loading: true };
        case LOGIN_SSO_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case LOGIN_SSO_FAILED:
            return { ...state, error: action.payload, loading: false };
        default:
            return { ...state };
    }
};

export default Auth;
